import { Inject, Injectable } from "@angular/core";
import { IMasterDataService } from "app/+common/contracts/master-data.service.contract";
import { IOrdersService } from "app/+common/contracts/orders.service.contract";
import * as _ from "lodash";
import { Garment } from "../model/garment.model";
import { OrderDetail } from "../model/order-detail.model";
import { Order } from "../model/order.model";
import { OrderDetailGarment } from "../model/orderDetailGarment.model";
import { LoggingService } from "./logging.service";

@Injectable()
export class OrdersService implements IOrdersService {

    constructor(@Inject('IMasterDataService') private masterDataService: IMasterDataService,
        private loggingService: LoggingService) {
    }

    private logOrders(orders: Order[]) {
        return orders.map(o => this.logOrder(o))
    }

    private logOrder(order: Order) {
        return {
            id: order.id,
            structureId: order.structureId,
            number: order.number,
            orderPhaseId: order.orderPhaseId,
            orderDetails: this.logOrderDetail(order.orderDetails),
            orderPhase: {
                id: order.orderPhase.id,
            },
        }
    }

    private logOrderDetail(orderDetail: OrderDetail[]): any {
        return orderDetail.map(od => {
            return {
                orderId: od.orderId,
                orderDetailId: od.orderDetailId,
                quantity: od.quantity,
                productId: od.productId,
                garments: od.garments = this.logGarments(od.garments)
            }
        })
    }

    logGarments(garments: Garment[]): any {
        return garments.map(g => {
            return {
                id: g.id,
                name: g.name,
                ownerId: g.ownerId,
                rfid: g.rfid,
                barcode: g.barcode,
                currentPhase: {
                    id: g.currentPhase.id
                }
            }
        })
    }

    public async saveOrdersState(orders: Order[]): Promise<Order[]> {
        const prodsAwait = orders.map(async oo => {
            try { this.loggingService.logTrace("saveOrdersState", { order: this.logOrder(oo) }) } catch (e) { this.loggingService.logTrace("saveOrdersState", { order: "log failed" }) }
            await this.saveOrderState(oo)
            oo.orderDetails.forEach((od) => {
                od.garments = od.garments.filter(g => g.currentPhase.id === 1)
            })
        })

        const prods = await Promise.all(prodsAwait)

        console.log(prods)

        const orderStruct = _.toPairs(this.groupByStructure(orders))
        const toSave = this.prepareUniqueOrders(_.cloneDeepWith(orderStruct))

        toSave.forEach(async (o) => await this.saveNewOrder(o))

        return orders
    }

    public async updateProductOnPremise(orders: Order[]) {
        orders.forEach(async oo => {
            oo.orderDetails.forEach((od) => {
                od.garments = od.garments.filter(g => g.currentPhase.id === 1)
            })
        })

        const orderStruct = _.toPairs(this.groupByStructure(orders))
        const toSave = this.prepareUniqueOrders(_.cloneDeepWith(orderStruct))
        toSave.forEach(async (o) => await this.masterDataService.updateProductOnPremise(o))
        return toSave
    }

    public prepareUniqueOrders(orderStruct: [string, Order[]][]) {
        return orderStruct.map((ords) => {
            const uniqueOD: OrderDetail[] = []
            const flatOD = _.flatMap(ords[1], o => o.orderDetails)
            const prodGroup = _.toPairs(_.groupBy(flatOD, p => p.productId))

            prodGroup.forEach(ord => uniqueOD.push(ord[1].reduce((t, o) => { t.garments.concat(o.garments); return t })))

            const oro = ords[1].sort((oa, ob) => { return new Date(ob.creationDate).getTime() - new Date(oa.creationDate).getTime() }).shift()
            oro.orderDetails = uniqueOD

            return oro
        })
    }

    public groupByStructure(orders: Order[]) {
        return _.groupBy(orders, "structureId")
    }

    public async saveOrderState(order: Order): Promise<void> {
        const orderToSend = _.cloneDeepWith(order);

        delete orderToSend.productOrders;
        delete orderToSend.orderDetails;
        var ret = this.masterDataService.saveOrderState(orderToSend).toPromise()
    }

    private async saveNewOrder(order: Order) {
        const newOrder = _.cloneDeepWith(order)
        newOrder.id = 0
        newOrder.orderPhaseId = 0
        const numberDesc = newOrder.number.split('_')
        newOrder.number = numberDesc[0] + '_' + (Number.parseInt(numberDesc[1] || '0') + 1)

        newOrder.orderDetails.forEach((od, i) => {
            od.quantity = od.garments.length
            od.orderDetailId = i + 1
        })

        const ret = await this.masterDataService.saveOrderAllocation(newOrder).toPromise()
        try { this.loggingService.logTrace("saveNewOrder", { order: this.logOrder(newOrder) }) } catch (e) { this.loggingService.logTrace("saveOrdersState", { order: "log failed" }) }
        return ret
    }

    public async setOrderDetailGarmentState(garments: Garment[], orderId: number, orderDetailId: number): Promise<any> {
        const odg = garments.map(g => { return new OrderDetailGarment(orderId, orderDetailId, g.id, 4) })
        return await this.masterDataService.setOrderDetailGarmentState(odg)
    }
}



// WEBPACK FOOTER //
// ./src/app/+core/common/services/orders.service.ts